import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';

const buttonstyles = css`
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  width: 45px;
  height: 45px;

  background-color: ${(props) =>
    props.color ? props.color : props.theme.palette.button.roundButton};
  border-radius: 50%;
  border: none;
  margin-left: ${(props) => (props.margin ? '1rem' : '0')};

  box-shadow: 2px 2px 5px 0px rgba(0, 0, 0, 0.3), 0 1px 2px rgba(0, 0, 0, 0.24);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  cursor: pointer;

  @media (min-width: 900px) {
    width: 3.5rem;
    height: 3.5rem;
  }

  svg {
    width: 100%;
    transition: 0.2s ease;
  }

  &:hover {
    background-color: ${(props) =>
      props.hover ? props.hover : props.theme.palette.button.roundButtonHover};
    color: ${(props) => props.theme.palette.button.icon};
    box-shadow: 14px 14px 28px rgba(0, 0, 0, 0.25),
      0 8px 8px rgba(0, 0, 0, 0.22);

    svg {
      transform: scale(1.05);
    }
  }

  &:focus {
    outline: none;
  }
  @media (max-height: 681px) and (min-width: 900px) {
    width: 2rem;
    height: 2rem;
    position: relative;
    top: -17px;
  }
  @media (max-width: 300px){
    width: 2.5rem;
    height: 2.5rem;
  }



  ${(props) =>
    props.tooltip
      ? `
    &::after {
      --scale: 0;
      content: attr(data-tooltip);
      position: absolute;
      bottom: -2.75rem;
      padding: .5rem;
      max-width: 5rem;
      background: ${props.theme.palette.button.roundButton};
      color: ${props.theme.palette.button.roundButtonIcon};
      border-radius: 5px;
      box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
      transform: scale(var(--scale));
      transition: 150ms transform;
      transform-origin: top center;
      z-index: 2;
    }

    &:hover::after {
      --scale: 1;
    }`
      : ''}

  ${(props) =>
    props.disabled
      ? `
    opacity: 0;
    pointer-events: none;
    `
      : 'opacity: 1'};
`;

export const Button = styled(Link)`
  ${buttonstyles};
`;

export const ActionButton = styled.button`
  ${buttonstyles};

  ${(props) =>
    props.opacity
      ? `
    opacity: 0.3;
    pointer-events: none;    
    padding: 0;    
  `
      : ''};
`;
